'use strict';

/**
 * @ngdoc function
 * @name thothAppApp.controller:ClientNewCtrl
 * @description
 * # ClientNewCtrl
 * Controller of the thothAppApp
 */
angular.module('thothApp.controllers')
  .controller('ClientNewCtrl', [
    '$scope', '$rootScope', 'Client', '$state', '$stateParams', 'GoogleApi', 'toaster', 'ProductCatalog', 'Pagination', 'ClientsGroup', function ($scope, $rootScope, Client, $state, $stateParams, GoogleApi, toaster, ProductCatalog, Pagination, ClientsGroup) {
      $rootScope.rootPath = {
        url: '',
        id: '',
      };
      $rootScope.currentPicker = null;
      $rootScope.clientRootPath = null;
      $scope.isProduction = [
        { id: 'true', name: "Sí" },
        { id: 'false', name: "No" }
      ];
      $scope.client_groups = [];
      ClientsGroup.index({params: { per_page: 'all', page: 1}}).then(function(response) {
        $scope.client_groups = response.data.client_groups;
      }, function(error) {
        ClientsGroup.error(error);
      });

      $scope.clientProductCatalogsAttributes= [];
      $scope.productCatalogs = [];
      $scope.clientProductCatalogsID =[];

      $scope.oldName = ''
      $rootScope.isPicked = false;
      if ($stateParams.clientId) {
        Client.find($stateParams.clientId).then(function (response) {
          const client = response.data.client;
          $scope.clientHash = { 'client': client };
          $scope.oldName = client.name;
          $rootScope.rootPath.url = client.drive_root_url;
          $rootScope.rootPath.id = client.drive_root_id;
          $rootScope.projectDriveId = client.project_drive_id;
          $rootScope.projectDriveFolderName = client.project_drive_folder_name;
          $rootScope.clientRootPath = angular.copy($rootScope.rootPath);

          $scope.clientProductCatalogsID = client.client_product_catalogs.map(product => ({
              product_id: product.product_catalog_id,
              annual_support_hours: product.annual_support_hours
            })
          );

          ProductCatalog.index().then(function (response) {
            response.data.products.forEach((product) => {
              const clientProduct = $scope.clientProductCatalogsID.find(item => item.product_id === product.id);
          
              if (clientProduct) {
                $scope.productCatalogs.push({
                  id: product.id,
                  name: product.name,
                  selected: true,
                  annual_support_hours: clientProduct.annual_support_hours
                });
              } else {
                $scope.productCatalogs.push({
                  id: product.id,
                  name: product.name,
                  selected: false
                });
              }
            });
          });

          $rootScope.isPicked = true;
          GoogleApi.getFolderName($scope.clientHash.client.drive_root_id).then(function (response) {
            $rootScope.rootPath.name = response.result.name;
            $rootScope.clientRootPath = angular.copy($rootScope.rootPath);
          });
          
          if ($scope.clientHash.client.project_drive_id) {
            GoogleApi.getFolderName($scope.clientHash.client.project_drive_id).then(function (response) {
              $scope.clientHash.client.project_drive_folder_name = response.result.name;
            });
          }
          
        }, function (error) {
          Client.error(error);
        });
      } else {
        $scope.clientHash = {
          'client': {
            'name': '',
            'client_code': '0',
            'email': '',
            'rfc': '',
            'complete_name': '',
            'was_prospect': false,
            'converted_to_prospect_by': null,
            'client_group_id': null
          }
        };
        Client.next_client_code().then((response) => {
          $scope.clientHash.client.client_code = response.data.client_code
        });
      }

      $scope.saveClient = function () {
        $rootScope.isPicked = true;
        const rootGoogleFolderId = $rootScope.rootPath.id;
        if ($scope.clientHash.client.hasOwnProperty("id")) {
          $scope.clientProductCatalogsAttributes = $scope.productCatalogs
          .filter(function(product) {
            return product.selected === true;
          })
          .map(function(productCatalog) {
            return {
              product_catalog_id: productCatalog.id,
              annual_support_hours: productCatalog.annual_support_hours
            };
          });

          $scope.clientHash.client.client_product_catalogs_attributes = $scope.clientProductCatalogsAttributes;


          if ($scope.clientHash.client.drive_root_id != $rootScope.rootPath.id) {
            GoogleApi.moveClientFolderStructure(
              $scope.clientHash.client.name,
              $scope.clientHash.client.drive_root_id,
              rootGoogleFolderId
            ).then((response) => {
              $scope.clientHash.client.drive_root_id = response.client_root_id;
              $scope.clientHash.client.drive_root_url = response.client_root_url;
              $scope.saveOrEditClient($scope.clientHash)
            }).catch((error) => {
              console.log(error)
              toaster.pop('error', 'Cliente', error);
            });
          } else {
            $scope.saveOrEditClient($scope.clientHash)
          }
        } else {
          if ($rootScope.rootPath) {
            // jscs:disable
            $scope.clientHash.client.drive_root_id = $rootScope.rootPath.id;
            $scope.clientHash.client.drive_root_url = $rootScope.rootPath.url;
            // jscs:enable
          }
          if ($scope.clientHash.client.client_group_id === "null") {
            $scope.clientHash.client.client_group_id = null;
          }
          Client.save($scope.clientHash).then((responseClient) => {
            $scope.clientHash = responseClient.data
            GoogleApi.createClientFolderStructure(
              $scope.clientHash.client.name,
              rootGoogleFolderId,
              true
            ).then((response) => {
              $scope.clientHash.client.drive_root_id = response.client_root_id;
              $scope.clientHash.client.drive_root_url = response.client_root_url;
              $scope.clientHash.client.project_drive_id = response.project_drive_id;
              $scope.clientHash.client.project_drive_folder_name = response.project_drive_folder_name;
              
              $scope.saveOrEditClient($scope.clientHash)
              toaster.pop('success', 'Cliente Creado', 'Se creo el cliente');
            }).catch((error) => {
              console.log(error)
              toaster.pop('error', 'Cliente', error);
            });
          }).catch((error) => {
            //Error while creating Client
            Client.error(error);
          });
        }
      };

      $scope.renameFolder = function (folderId, name) {
        GoogleApi.updateFolderName(folderId, name).then(function () {
          toaster.pop('success', 'Drive Actualizado', 'Se actualizo el cliente');
        }, function (error) {
          Project.error(error);
          toaster.pop('error', 'Cliente', error);
        });
      }

      $scope.renameChildFolders = function (folderId, name, oldName) {
        GoogleApi.renameChildClientFolders(name, folderId, oldName).then(function () {
          toaster.pop('success', 'Drive Actualizado', 'Se actualizaron las carpetas del cliente');
        }, function (error) {
          Client.console.error(error);
        });
      }

      $scope.saveOrEditClient = function (clientHash) {
        if (clientHash.client.client_group_id === "null") {
          clientHash.client.client_group_id = null;
        }
        Client.save(clientHash).then((response) => {
          $scope.clientHash = {
            'client': {
              'name': '',
              'client_code': $scope.clientHash.client.client_code
            }
          };
          $state.go('app.clients.show', { clientId: response.data.client.id });
          toaster.pop('success', 'Cliente Actualizado', 'Se actualizo el cliente');
        }).catch((error) => {
          //Error while creating Client
          Client.error(error);
        });
      }

      $scope.selectFolder = function () {
        $rootScope.currentPicker = 'client_root';
        GoogleApi.pickerApiLoad(GoogleApi.getClientBaseFolderId(), 'folder');
      }

      $scope.selectClientProjectFolder = function () {
        $rootScope.currentPicker = 'client_project';
        GoogleApi.pickerApiLoad($rootScope.rootPath.id, 'folder');
      }

      $scope.$watch(function () { return $rootScope.rootPath; }, function (newVal) {
        if (!newVal || !newVal.id || !$rootScope.currentPicker) return;

        if ($rootScope.currentPicker === 'client_root') {
          $rootScope.clientRootPath = angular.copy(newVal);
          $scope.clientHash.client.drive_root_id = newVal.id;
          $scope.clientHash.client.drive_root_url = newVal.url;
        }

        if ($rootScope.currentPicker === 'client_project') {
          $scope.clientHash.client.project_drive_id = newVal.id;
          $scope.clientHash.client.project_drive_folder_name = newVal.name;

          if ($rootScope.clientRootPath) {
            $rootScope.rootPath = angular.copy($rootScope.clientRootPath);
          }
        }

        $rootScope.currentPicker = null;
      }, true);

      $scope.checkUrl = function () {
        if ($rootScope.rootPath.url.includes("https://drive.google.com/drive/", "folders/")) {
          var index = $rootScope.rootPath.url.indexOf("folders/") + 8
          $rootScope.rootPath.id = $rootScope.rootPath.url.substr(index)
        } else {
          var error = {
            status: 422,
            data: {
              errors: {
                base: ['Favor de verificar la ruta del proyecto.']
              }
            }
          }
          Client.error(error);
        }
      };
    }]);
